wbApp.controller('FirebaseCtrl', ['$scope', 'securitySvc', '$window', function ($scope, securitySvc, $window) {
    if (securitySvc.isAuthenticated() && String.prototype.isNullOrWhitespace(securitySvc.loggedInUser().fullName)) {
        if (!$window.location.pathname.startsWith("/MyAccount")) {
            $window.location.href = "/MyAccount?tabName=user-account";
        }
    }
}]);